<template>
  <div class="history-changes-view">
    <v-btn class="btn-transparent" @click.native.stop="historyChangesView(true)">
      {{ $t('Посмотреть') }}
    </v-btn>
    <v-dialog v-model="historyChangesDialog" max-width="900">
      <v-card class="modal history-changes-modal">
        <div class="modal-head">
          {{ $t('Запись от') }} {{ new Date(history.date) | dateFormat('DD.MM.YYYY HH:mm') }},
          {{ $t('Пользователь') }}: {{ history.email }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="historyChangesDialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <template v-if="history.label === 'createNpa' || history.label === 'createNpaVersionBlock' || history.label === 'createNpaDocument'">
            <div class="table-overflow">
              <table class="table">
                <tbody>
                  <template v-if="history.namespace === 'App\\Entity\\Npa'">
                    <tr v-if="history.fields.id">
                      <td>{{ $t("Идентификатор проекта НПА") }}</td>
                      <td>{{ history.fields.id }}</td>
                    </tr>
                    <tr v-if="history.fields.status">
                      <td>{{ $t("Статус") }}</td>
                      <td>{{ history.fields.status.name }}</td>
                    </tr>
                    <tr v-if="history.fields.nameKg">
                      <td>{{ $t("Наименование на государственном языке") }}</td>
                      <td>{{ history.fields.nameKg }}</td>
                    </tr>
                    <tr v-if="history.fields.name">
                      <td>{{ $t("Наименование на официальном языке") }}</td>
                      <td>{{ history.fields.name }}</td>
                    </tr>
                    <tr v-if="history.fields.view.name">
                      <td>{{ $t("Вид проекта НПА") }}</td>
                      <td>{{ history.fields.view.name }}</td>
                    </tr>
                    <tr v-if="history.fields.region">
                      <td>{{ $t("Область") }}</td>
                      <td>{{ history.fields.region ? history.fields.region.name : '' }}</td>
                    </tr>
                    <tr v-if="history.fields.district">
                      <td>{{ $t("Район") }}</td>
                      <td>{{ history.fields.district ? history.fields.district.name : '' }}</td>
                    </tr>
                    <tr v-if="history.fields.edition">
                      <td>{{ $t("Редакция") }}</td>
                      <td>{{ history.fields.edition.name }}</td>
                    </tr>
                    <tr v-if="history.fields.developer.name">
                      <td>{{ $t("Разработчик") }}</td>
                      <td>
                        <v-icon
                          v-if="history.fields.developer.status === false"
                          class="nv_icon mr-1"
                          x-small
                        />
                        {{ history.fields.developer.name }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.initiator">
                      <td>{{ $t("Инициатор проекта НПА") }}</td>
                      <td>{{ history.fields.initiator ? history.fields.initiator.name : '' }}</td>
                    </tr>
                    <tr v-if="history.fields.category">
                      <td>{{ $t("Категории") }}</td>
                      <td>
                        <div class="npa-category-list">
                          <div class="tags">
                            <template v-if="history.fields.category">
                              <span
                                v-for="item in history.fields.category"
                                class="tag"
                                :key="item.id"
                              >
                              {{ item.name }}
                            </span>
                            </template>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.branchLaw">
                      <td>{{ $t("Отрасли") }}</td>
                      <td>
                        <div class="npa-category-list">
                          <div class="tags">
                            <span
                              class="tag"
                              v-for="item in history.fields.branchLaw"
                              :key="item.id"
                            >
                              {{ item.name }}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.projectGoalKg">
                      <td>{{ $t("Цель проекта НПА на государственном языке") }}</td>
                      <td><div v-html="history.fields.projectGoalKg"></div></td>
                    </tr>
                    <tr v-if="history.fields.projectGoal">
                      <td>{{ $t("Цель проекта НПА на официальном языке") }}</td>
                      <td><div v-html="history.fields.projectGoal"></div></td>
                    </tr>
                    <tr v-if="history.fields.publishDate">
                      <td>{{ $t("Дата публикации") }}</td>
                      <td>{{ new Date(history.fields.publishDate) | dateFormat('DD.MM.YYYY') }}</td>
                    </tr>
                    <tr v-if="history.fields.discussionPeriodDateFrom || history.fields.discussionPeriodDateTo">
                      <td>{{ $t("Период обсуждения проекта") }}</td>
                      <td>
                        {{ new Date(history.fields.discussionPeriodDateFrom) | dateFormat('DD.MM.YYYY') }}
                        -
                        {{ new Date(history.fields.discussionPeriodDateTo) | dateFormat('DD.MM.YYYY') }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.keyword">
                      <td>{{ $t("Ключевые слова") }}</td>
                      <td>
                        <div class="form-keywords">
                          <div class="tags">
                            <span
                              class="tag"
                              v-for="item in history.fields.keyword"
                              :key="item.id"
                            >
                              #{{ item.name }}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.fundingRequired">
                      <td>{{ $t("Требует финансирования") }}</td>
                      <td>
                        <span v-if="history.fields.fundingRequired && history.fields.fundingRequired === true">{{ $t("да") }}</span>
                        <span v-else>{{ $t("нет") }}</span>
                      </td>
                    </tr>
                    <tr v-if="history.fields.entrepreneurshipAffect">
                      <td>{{ $t("Затрагивает предпринимательскую деятельность") }}</td>
                      <td>
                        <span
                          v-if="history.fields.entrepreneurshipAffect && history.fields.entrepreneurshipAffect === true">{{ $t("да") }}</span>
                        <span v-else>{{ $t("нет") }}</span>
                      </td>
                    </tr>
                    <tr v-if="history.fields.links">
                      <td>{{ $t("Ссылки на НПА") }}</td>
                      <td>
                        <div class="link-npa-main">
                          <ul class="link-list">
                            <li
                              v-for="(link, index) of history.fields.links"
                              :key="index"
                            >
                              <a
                                target="_blank"
                                :href="link.text"
                                class="link-npa"
                              >
                                {{ link.text }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <template v-for="(npaVersions, index) in history.fields.npaVersions">
                      <tr :key="index" v-if="npaVersions.fileKg">
                        <td>
                          {{ $t("Файл проекта НПА на государственном языке") }}
                        </td>
                        <td>
                          {{ npaVersions.fileKg }}
                        </td>
                      </tr>
                      <tr :key="index" v-if="npaVersions.file">
                        <td>
                          {{ $t("Файл проекта НПА на официальном языке") }}
                        </td>
                        <td>
                          {{ npaVersions.file }}
                        </td>
                      </tr>
                      <tr v-for="item in npaVersions.npaVersionBlocks" :key="item.id">
                        <td>
                          {{ item.lang == 'ru' ? $t('Текст проекта НПА на официальном языке') : $t('Текст проекта НПА на государственном языке') }}
                        </td>
                        <td>
                          <div v-html="item.text"></div>
                        </td>
                      </tr>
                    </template>
                    <template v-if="history.fields.npaDocuments">
                      <tr v-for="document in history.fields.npaDocuments" :key="document.id">
                        <td>
                          {{ document.type.name }}
                        </td>
                        <td>
                          {{ document.file }}
                        </td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="history.namespace === 'App\\Entity\\NpaVersionBlock'">
                    <template v-if="history.fields.text">
                      <tr>
                        <td>
                          {{ history.fields.lang == 'ru' ? $t("Текст блока проекта НПА на официальном языке") : $t("Текст блока проекта НПА на государственном языке") }}
                        </td>
                        <td>
                          <div v-html="history.fields.text"></div>
                        </td>
                      </tr>
                    </template>
                    <template v-if="history.fields.commented">
                      <tr>
                        <td>
                          {{ $t("Комментировать") }}
                        </td>
                        <td>
                          <template v-if="history.fields.commented === true">
                            {{ $t('да') }}
                          </template>
                          <template v-else>
                            {{ $t('нет') }}
                          </template>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="history.namespace === 'App\\Entity\\NpaDocument'">
                    <template v-if="history.fields.type">
                      <tr>
                        <td>
                          {{ history.fields.type.name }}
                        </td>
                        <td>
                          {{ history.fields.file }}
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </div>
          </template>
          <template v-if="history.label === 'editNpaVersionBlock' || history.label === 'editNpa' || history.label === 'editNpaVersion'">
            <div class="table-overflow">
              <table class="table table-field-changed">
                <thead>
                <tr>
                  <td>{{ $t('Наименование поля') }}</td>
                  <td class="text-center">{{ $t('Старое значение') }}</td>
                  <td class="text-center">{{ $t('Новое значение') }}</td>
                </tr>
                </thead>
                <tbody>
                  <template v-if="history.namespace == 'App\\Entity\\NpaVersionBlock'">
                    <tr v-if="history.fields.text">
                      <td>{{ $t("Текст блока проекта НПА") }}</td>
                      <td v-for="(item, index) in history.fields.text" :key="index">
                        <div v-html="item"></div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.commented">
                      <td>{{ $t("Комментировать") }}</td>
                      <td v-for="(item, index) in history.fields.commented" :key="index">
                        <template v-if="item === true">
                          {{ $t('да') }}
                        </template>
                        <template v-else>
                          {{ $t('нет') }}
                        </template>
                      </td>
                    </tr>
                  </template>
                  <template v-if="history.namespace == 'App\\Entity\\NpaVersion'">
                    <tr v-if="history.fields.fileKg">
                      <td>{{ $t("Файл проекта НПА на государственном языке") }}</td>
                      <td v-for="(item, index) in history.fields.fileKg" :key="index">
                        {{ item }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.file">
                      <td>{{ $t("Файл проекта НПА на официальном языке") }}</td>
                      <td v-for="(item, index) in history.fields.file" :key="index">
                        {{ item }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="history.namespace == 'App\\Entity\\Npa'">
                    <tr v-if="history.fields.name">
                      <td>{{ $t("Наименование на официальном языке") }}</td>
                      <td v-for="(item, index) in history.fields.name" :key="index">
                        {{ item }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.nameKg">
                      <td>{{ $t("Наименование на государственном языке") }}</td>
                      <td v-for="(item, index) in history.fields.nameKg" :key="index">
                        {{ item }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.view">
                      <td>{{ $t("Вид проекта НПА") }}</td>
                      <td v-for="(item, index) in history.fields.view" :key="index">
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.region">
                      <td>{{ $t("Область") }}</td>
                      <td v-for="(item, index) in history.fields.region" :key="index">
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.district">
                      <td>{{ $t("Район") }}</td>
                      <td v-for="(item, index) in history.fields.district" :key="index">
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.edition">
                      <td>{{ $t("Редакция") }}</td>
                      <td v-for="(item, index) in history.fields.edition" :key="index">
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.developer">
                      <td>{{ $t("Разработчик") }}</td>
                      <td v-for="(item, index) in history.fields.developer" :key="index">
                        <v-icon
                          v-if="item && item.status === false"
                          class="nv_icon mr-1"
                          x-small
                        />
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.initiator">
                      <td>{{ $t("Инициатор") }}</td>
                      <td v-for="(item, index) in history.fields.initiator" :key="index">
                        {{ item ? item.name : '' }}
                      </td>
                    </tr>
                    <template v-if="history.fields.category">
                      <tr v-if="history.fields.category.deleteDiff">
                        <td>{{ $t("Категории") }}</td>
                        <td>
                          {{ $t("Удалено") }}
                        </td>
                        <td>
                          <span v-for="(category, index) in history.fields.category.deleteDiff" :key="index">
                            {{ category.name }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="history.fields.category.insertDiff">
                        <td>{{ $t("Категории") }}</td>
                        <td>
                          {{ $t("Добавлено") }}
                        </td>
                        <td>
                          <span v-for="(category, index) in history.fields.category.insertDiff" :key="index">
                            {{ category.name }}<br/>
                          </span>
                        </td>
                      </tr>
                    </template>
                    <template v-if="history.fields.branchLaw">
                      <tr v-if="history.fields.branchLaw.deleteDiff">
                        <td>{{ $t("Отрасли") }}</td>
                        <td>
                          {{ $t("Удалено") }}
                        </td>
                        <td>
                          <span v-for="(branchLaw, index) in history.fields.branchLaw.deleteDiff" :key="index">
                            {{ branchLaw.name }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="history.fields.branchLaw.insertDiff">
                        <td>{{ $t("Отрасли") }}</td>
                        <td>
                          {{ $t("Добавлено") }}
                        </td>
                        <td>
                          <span v-for="(branchLaw, index) in history.fields.branchLaw.insertDiff" :key="index">
                            {{ branchLaw.name }}<br/>
                          </span>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="history.fields.projectGoal">
                      <td>{{ $t("Цель проекта НПА на официальном языке") }}</td>
                      <td v-for="(item, index) in history.fields.projectGoal" :key="index">
                        <div v-html="item"></div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.projectGoalKg">
                      <td>{{ $t("Цель проекта НПА на государственном языке") }}</td>
                      <td v-for="(item, index) in history.fields.projectGoalKg" :key="index">
                        <div v-html="item"></div>
                      </td>
                    </tr>
                    <tr v-if="history.fields.publishDate">
                      <td>{{ $t("Дата публикации") }}</td>
                      <td v-for="(item, index) in history.fields.publishDate" :key="index">
                        {{ new Date(item) | dateFormat('DD.MM.YYYY') }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.discussionPeriodDateFrom">
                      <td>{{ $t("Период обсуждения проекта с") }}</td>
                      <td v-for="(item, index) in history.fields.discussionPeriodDateFrom" :key="index">
                        {{ new Date(item) | dateFormat('DD.MM.YYYY') }}
                      </td>
                    </tr>
                    <tr v-if="history.fields.discussionPeriodDateTo">
                      <td>{{ $t("Период обсуждения проекта по") }}</td>
                      <td v-for="(item, index) in history.fields.discussionPeriodDateTo" :key="index">
                        {{ new Date(item) | dateFormat('DD.MM.YYYY') }}
                      </td>
                    </tr>
                    <template v-if="history.fields.keyword">
                      <tr v-if="history.fields.keyword.deleteDiff">
                        <td>{{ $t("Ключевые слова") }}</td>
                        <td>
                          {{ $t("Удалено") }}
                        </td>
                        <td>
                          <span v-for="(keyword, index) in history.fields.keyword.deleteDiff" :key="index">
                            {{ keyword.name }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="history.fields.keyword.insertDiff">
                        <td>{{ $t("Ключевые слова") }}</td>
                        <td>
                          {{ $t("Добавлено") }}
                        </td>
                        <td>
                          <span v-for="(keyword, index) in history.fields.keyword.insertDiff" :key="index">
                            {{ keyword.name }}<br/>
                          </span>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="history.fields.fundingRequired">
                      <td>{{ $t("Требует финансирования") }}</td>
                      <td v-for="(item, index) in history.fields.fundingRequired" :key="index">
                        <span v-if="item && item === true">{{ $t("да") }}</span>
                        <span v-else>{{ $t("нет") }}</span>
                      </td>
                    </tr>
                    <tr v-if="history.fields.entrepreneurshipAffect">
                      <td>{{ $t("Затрагивает предпринимательскую деятельность") }}</td>
                      <td v-for="(item, index) in history.fields.entrepreneurshipAffect" :key="index">
                        <span v-if="item && item === true">{{ $t("да") }}</span>
                        <span v-else>{{ $t("нет") }}</span>
                      </td>
                    </tr>
                    <tr v-if="history.fields.links">
                      <td>{{ $t("Ссылки на НПА") }}</td>
                      <td v-for="(link, index) in history.fields.links" :key="index">
                        <div v-for="(item, index) in link" :key="index">
                          <a target="_blank" :href="item.text" class="link-npa">
                            {{ item.text }}
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </template>
          <template v-if="history.label === 'deleteNpaVersionBlock' || history.label === 'deleteNpaDocument'">
            <div class="table-overflow">
              <table class="table">
                <thead>
                <tr>
                  <td>{{ $t('Наименование') }}</td>
                  <td class="text-center">{{ $t('Старое значение') }}</td>
                  <td class="text-center">{{ $t('Новое значение') }}</td>
                </tr>
                </thead>
                <tbody>
                  <template v-if="history.namespace == 'App\\Entity\\NpaVersionBlock'">
                    <tr v-if="history.fields.text">
                      <td>{{ $t("Блок") }}</td>
                      <td>
                        <div v-html="history.fields.text"></div>
                      </td>
                      <td>
                        {{ $t('Удален') }}
                      </td>
                    </tr>
                  </template>
                  <template v-if="history.namespace == 'App\\Entity\\NpaDocument'">
                    <tr v-if="history.fields.type">
                      <td>{{ $t("Сопроводительный документ") }}</td>
                      <td>
                        {{ history.fields.type.name }}
                      </td>
                      <td>
                        {{ $t('Удален') }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NpaModel from "@/model/npa";

export default {
  props: {
    historyId: Number
  },
  data: () => ({
    history: [],
    historyChangesDialog: false,
    baseUrl: process.env.VUE_APP_BACK_URL,
  }),
  methods: {
    historyChangesView(flag) {
      this.historyChangesDialog = flag
      NpaModel.getNpaFieldHistoryInfo(this.historyId)
        .then((response) => {
          this.history = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
</style>
